import { useTranslation } from "react-i18next";
import DeviceMetricCard from "./DeviceMetricCard";
import "./DeviceMetricCards.scss";

const DeviceMetricCards = ({ ...props }) => {
    const { t, i18n } = useTranslation();
    const className = 'col-12 sm:col-12 md:col-6 lg:col-4 xl:col-2 mr-0 pr-0 pl-3';
    return (
        <div className='metric-cards'>
            <div className="grid w-full mt-2 mb-2">
                <div className={className}>
                    <DeviceMetricCard healthState='ALL' />
                </div>
                <div className={className}>
                    <DeviceMetricCard healthState='ON_LINE' />
                </div>
                <div className={className}>
                    <DeviceMetricCard healthState='OFF_LINE' />
                </div>
                <div className={className}>
                    <DeviceMetricCard healthState='WITH_ERROR' />
                </div>
                <div className={className}>
                    <DeviceMetricCard healthState='UNCONFIGURED' />
                </div>
                <div className={className}>
                    <DeviceMetricCard healthState='UNASSIGNED' />
                </div>
            </div>
        </div>
    )
}

export default DeviceMetricCards;